import { normalizeNetworkId } from "../../../Supplier/Pages/PredictInstant/AmendTariffs/types";
import { formatCustomerDealSummaryPrimary, formatCustomerDealSummarySecondary, getDealId, getMonthlyCost, getSupplierEmail, getSupplierName, getSupplierPhone, parseDealDate, } from "../../../Supplier/Pages/PredictInstant/DealsWon/chosenPackageHelpers";
export { formatDealDate, formatDealTime, } from "../../../Supplier/Pages/PredictInstant/DealsWon/chosenPackageHelpers";
export const mapChosenPackageToChosenDeal = (raw) => {
    const parameters = raw.parameters;
    const networkId = normalizeNetworkId(String(raw.network ?? parameters?.platform ?? ""));
    const id = getDealId(raw);
    if (!networkId || !id) {
        return null;
    }
    return {
        id,
        date: parseDealDate(raw),
        supplierName: getSupplierName(raw),
        supplierEmail: getSupplierEmail(raw),
        supplierPhone: getSupplierPhone(raw),
        dealSummaryPrimary: formatCustomerDealSummaryPrimary(raw),
        dealSummarySecondary: formatCustomerDealSummarySecondary(raw),
        monthlyCost: getMonthlyCost(raw),
        networkId,
    };
};
export const mapChosenPackagesToChosenDeals = (packages) => packages
    .map((package_) => mapChosenPackageToChosenDeal(package_))
    .filter((deal) => deal !== null);
